import { UploadFile } from 'antd/lib/upload/interface';
import { AttachmentUploadMapType } from './ExcelS3Upload.types';

export const initialState = {
  fileList: [] as UploadFile[],
  attachmentUploadMap: {
    uploadMap: {},
    s3Links: [],
    uploading: false,
  } as AttachmentUploadMapType,
  isLoading: false,
  isUploading: false,
  isDownloading: false,
};
